<template>
  <div class="">
    <h3 class="pt-0 mt-0 pb-0">{{ $t('common.customer_type')}}</h3>
    <v-card class="mt-2" elevation="0">
      <v-flex xs12 lg6>
        <v-form ref="customerForm">
          <v-text-field
                  v-if="fetched || !!this.$route.params.id"
                  v-model="customerType"
                  :rules="[(v) => !!v || $t('form.validationErrors.field_is_required'), (v) => (!!v) || $t('form.validationErrors.must_be_greater', [0])]"
                  :value="customerType"
                  :label="$t('common.title')"
                  outlined
          ></v-text-field>
          <v-divider></v-divider>
          <v-spacer></v-spacer>
          <v-btn
                  :disabled="savingInProgress"
                  :loading="savingInProgress"
                  class="mt-5 white--text mr-4"
                  elevation="0"
                  color="red"
                  @click="$router.push({name: 'settings-customer-types'});"
                  @keyup.enter="$router.push({name: 'settings-customer-types'});"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
                  :disabled="savingInProgress"
                  :loading="savingInProgress"
                  class="mt-5"
                  elevation="0"
                  color="primary"
                  @click="submit"
                  @keyup.enter="submit"
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-form>
      </v-flex>
    </v-card>
  </div>
</template>
<script>
  import { required, email, sameAs, minLength,  } from "vuelidate/lib/validators";
  import { mapState } from 'vuex';
  import { mapFields } from 'vuex-map-fields';
  export default {
    data: () => ({
        emptyCustomerType:{
            name:''
        }
    }),
    created(){
        this.onLoad();
    },

    watch: {
        '$route' (to, from) {
            this.onLoad();
        }
    },
    computed: {
        ...mapFields('customer_types', [
            'fetched',
            'savingInProgress',
            'customerTypes'
        ]),
        customerType:{
            // getter
            get: function() {
                if(this.$route.params.id>0 && this.fetched) {
                    return this.customerTypes.filter(customerType => Number(customerType.id) === Number(this.$route.params.id))[0] && this.customerTypes.filter(customerType => Number(customerType.id) === Number(this.$route.params.id))[0].name
                } else{
                    return this.emptyCustomerType.name;
                }
            },
            // setter
            set: function(newValue){
                if(this.$route.params.id>0) {
                    let customerType = this.customerTypes.filter(customerType => Number(customerType.id) === Number(this.$route.params.id))
                    customerType[0].name = newValue;
                } else {
                    this.emptyCustomerType.name = newValue;
                }
            }
        }
    },
    methods: {
        onLoad(){

            if(this.$route.params.id>0) {
                this.$store.dispatch('customer_types/get').
                then(()=>{
                    if(!this.customerTypes.filter(item => Number(item.id)===Number(this.$route.params.id))) {
                        this.$router.push({ name: '404'})
                    }
                });
            }
        },
        submit(){
            if(this.$refs['customerForm'].validate()) {
                if (this.$route.params.id) {
                    this.$store.dispatch('customer_types/update', {id: this.$route.params.id}).then((id)=>{
                        if (id > 0) {
                            this.$router.push({name: 'settings-customer-types'});
                        }
                    })
                } else {
                    this.$store.dispatch('customer_types/store', {customerType: this.emptyCustomerType}).then((id) => {
                        if (id > 0) {
                            this.$router.push({name: 'settings-customer-types'});
                        }
                    })
                }
            }
        }
    },
  }
</script>